var _sodipodiNamedview, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 426.069 426.069",
    style: {
      enableBackground: "new 0 0 426.069 426.069"
    },
    xmlSpace: "preserve",
    sodipodiDocname: "plant-svgrepo-com.svg",
    inkscapeVersion: "1.2.1 (9c6d41e4, 2022-07-14)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs164"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2710"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    },
    id: "rect2712",
    width: 266.345,
    height: 75.920792,
    x: 80.069443,
    y: 352.63745
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2714"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 0.997877
    },
    id: "rect2716",
    width: 255.9733,
    height: 389.56067,
    x: 65.963943,
    y: -36.923214
  }))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview162",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    showgrid: "false"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g129"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#65a30d",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.83929,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path10045",
    ry: 45.553898,
    rx: 23.751205,
    cy: 209.51488,
    cx: 11.469936,
    transform: "matrix(0.67246329,-0.74013048,0.74226918,0.67010183,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#65a30d",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.81406,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path10045-4",
    ry: 45.111706,
    rx: 23.559603,
    cy: 275.90292,
    cx: -61.895382,
    transform: "matrix(0.66627278,-0.74570811,0.73665401,0.67626983,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#65a30d",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.81406,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path10045-4-6",
    ry: 45.111706,
    rx: 23.559603,
    cy: 104.65645,
    cx: -276.58908,
    transform: "matrix(-0.68319169,-0.73023908,0.73938712,-0.67328054,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#65a30d",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.81406,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path10045-4-6-0",
    ry: 45.111706,
    rx: 23.559603,
    cy: 33.957802,
    cx: -349.45947,
    transform: "matrix(-0.68319169,-0.73023908,0.73938712,-0.67328054,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#65a30d",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.81406,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path10045-4-6-0-3",
    ry: 45.111706,
    rx: 23.559603,
    cy: -61.511501,
    cx: -211.80138,
    transform: "matrix(-0.99921559,0.0396006,-0.02612021,-0.99965881,0,0)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g109"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g113"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g119"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g123"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 338.39,419.187 C 330.689,400.23 314.117,383.22 291.726,371.292 270.277,359.866 244.893,353.518 218.035,352.816 v -68.249 l 14.207,-13.611 c 1.388,0.117 3.28,0.225 5.557,0.225 8.423,0 24.712,-1.543 39.17,-11.881 17.102,-12.228 26.797,-32.753 28.814,-61.006 0.1,-1.385 -0.382,-2.748 -1.328,-3.764 -0.945,-1.016 -2.272,-1.593 -3.658,-1.593 -0.001,0 -0.001,0 -0.002,0 -1.681,0 -41.416,0.291 -62.905,24.903 -10.419,11.934 -14.667,27.404 -12.674,45.999 l -7.18,6.879 V 182.82 l 13.837,-13.147 c 1.378,0.115 3.256,0.222 5.517,0.222 0.002,0 0.001,0 0.002,0 8.43,0 24.733,-1.544 39.215,-11.876 17.147,-12.236 26.865,-32.779 28.886,-61.06 0.099,-1.386 -0.383,-2.749 -1.329,-3.766 -0.946,-1.015 -2.271,-1.591 -3.658,-1.591 h -0.004 c -1.684,0.002 -41.468,0.319 -62.971,24.965 -10.415,11.936 -14.662,27.399 -12.675,45.979 l -6.819,6.479 V 99.253 c 13.487,-9.059 21.295,-20.61 23.211,-34.376 4.334,-31.152 -23.436,-61.954 -24.619,-63.25 -0.977,-1.068 -2.374,-1.67 -3.813,-1.625 -1.447,0.035 -2.807,0.694 -3.729,1.809 -19.701,23.784 -27.692,45.714 -23.753,65.18 3.722,18.382 17.015,28.794 22.703,32.495 v 69.539 l -6.819,-6.48 c 1.987,-18.578 -2.26,-34.042 -12.674,-45.977 C 167.041,91.922 127.256,91.605 125.573,91.603 h -0.005 c -1.387,0 -2.711,0.576 -3.657,1.591 -0.946,1.017 -1.429,2.38 -1.329,3.766 2.02,28.28 11.738,48.823 28.886,61.06 14.481,10.333 30.786,11.876 39.216,11.876 2.261,0 4.139,-0.106 5.517,-0.222 l 13.837,13.147 v 87.899 l -7.179,-6.878 c 1.992,-18.595 -2.255,-34.065 -12.674,-45.999 -21.49,-24.612 -61.225,-24.903 -62.906,-24.903 h -10e-4 c -1.388,0 -2.714,0.577 -3.659,1.593 -0.945,1.016 -1.427,2.379 -1.328,3.764 2.018,28.253 11.713,48.778 28.814,61.006 14.459,10.338 30.748,11.881 39.17,11.881 2.277,0 4.17,-0.108 5.558,-0.225 l 14.206,13.61 v 68.25 c -26.858,0.701 -52.242,7.05 -73.691,18.476 -22.391,11.928 -38.963,28.938 -46.664,47.895 -0.626,1.542 -0.444,3.294 0.484,4.674 0.93,1.381 2.484,2.208 4.148,2.208 h 241.445 c 1.664,0 3.219,-0.827 4.148,-2.208 0.925,-1.383 1.107,-3.135 0.481,-4.677 z M 245.394,224.45 c 14.141,-16.226 38.901,-20.215 49.887,-21.194 -5.347,46.247 -33.238,56.436 -52.665,57.763 l 30.263,-28.993 c 1.994,-1.91 2.061,-5.075 0.151,-7.069 -1.91,-1.995 -5.076,-2.063 -7.069,-0.151 l -31.216,29.905 c 0.11,-12.095 3.666,-22.249 10.649,-30.261 z m -0.359,-101.277 c 14.151,-16.251 38.945,-20.262 49.948,-21.25 -5.534,47.199 -35.436,56.439 -52.616,57.775 l 30.517,-28.995 c 2.002,-1.902 2.083,-5.067 0.181,-7.069 -1.901,-2 -5.065,-2.082 -7.068,-0.181 l -31.61,30.035 c 0.099,-12.114 3.655,-22.286 10.648,-30.315 z m -84.962,0.28 c -2.002,-1.9 -5.166,-1.82 -7.068,0.181 -1.902,2.002 -1.822,5.167 0.18,7.069 l 30.516,28.995 c -17.181,-1.337 -47.081,-10.586 -52.616,-57.784 10.982,0.972 35.719,4.95 49.921,21.226 7.011,8.035 10.577,18.217 10.677,30.347 z m 0.036,101.351 c -1.994,-1.909 -5.158,-1.844 -7.07,0.151 -1.91,1.994 -1.842,5.159 0.152,7.069 l 30.263,28.993 c -19.428,-1.326 -47.322,-11.516 -52.665,-57.771 10.967,0.963 35.67,4.921 49.859,21.172 7.002,8.019 10.568,18.182 10.677,30.292 z M 195.133,65.007 c -3.063,-15.134 2.942,-32.627 17.855,-52.06 7.015,9.117 21.171,30.406 18.348,50.581 -1.234,8.822 -5.705,16.584 -13.302,23.172 V 56.768 c 0,-2.762 -2.238,-5 -5,-5 -2.762,0 -5,2.238 -5,5 V 86.886 C 203.146,82.483 197.211,75.275 195.133,65.007 Z m -94.906,351.062 c 17.45,-31.73 62.417,-53.322 112.808,-53.322 50.391,0 95.357,21.592 112.808,53.322 z",
    id: "path127",
    style: {
      display: "inline",
      fill: "#3f6212",
      fillOpacity: 1
    },
    clipPath: "url(#clipPath2714)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0,0",
    id: "path2731",
    className: "UnoptimicedTransforms",
    style: {
      fill: "#ca8a04",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2727",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000000",
      strokeOpacity: 1
    },
    className: "UnoptimicedTransforms"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 338.39,419.187 C 330.689,400.23 314.117,383.22 291.726,371.292 270.277,359.866 244.893,353.518 218.035,352.816 v -68.249 l 14.207,-13.611 c 1.388,0.117 3.28,0.225 5.557,0.225 8.423,0 24.712,-1.543 39.17,-11.881 17.102,-12.228 26.797,-32.753 28.814,-61.006 0.1,-1.385 -0.382,-2.748 -1.328,-3.764 -0.945,-1.016 -2.272,-1.593 -3.658,-1.593 -0.001,0 -0.001,0 -0.002,0 -1.681,0 -41.416,0.291 -62.905,24.903 -10.419,11.934 -14.667,27.404 -12.674,45.999 l -7.18,6.879 V 182.82 l 13.837,-13.147 c 1.378,0.115 3.256,0.222 5.517,0.222 0.002,0 0.001,0 0.002,0 8.43,0 24.733,-1.544 39.215,-11.876 17.147,-12.236 26.865,-32.779 28.886,-61.06 0.099,-1.386 -0.383,-2.749 -1.329,-3.766 -0.946,-1.015 -2.271,-1.591 -3.658,-1.591 h -0.004 c -1.684,0.002 -41.468,0.319 -62.971,24.965 -10.415,11.936 -14.662,27.399 -12.675,45.979 l -6.819,6.479 V 99.253 c 13.487,-9.059 21.295,-20.61 23.211,-34.376 4.334,-31.152 -23.436,-61.954 -24.619,-63.25 -0.977,-1.068 -2.374,-1.67 -3.813,-1.625 -1.447,0.035 -2.807,0.694 -3.729,1.809 -19.701,23.784 -27.692,45.714 -23.753,65.18 3.722,18.382 17.015,28.794 22.703,32.495 v 69.539 l -6.819,-6.48 c 1.987,-18.578 -2.26,-34.042 -12.674,-45.977 C 167.041,91.922 127.256,91.605 125.573,91.603 h -0.005 c -1.387,0 -2.711,0.576 -3.657,1.591 -0.946,1.017 -1.429,2.38 -1.329,3.766 2.02,28.28 11.738,48.823 28.886,61.06 14.481,10.333 30.786,11.876 39.216,11.876 2.261,0 4.139,-0.106 5.517,-0.222 l 13.837,13.147 v 87.899 l -7.179,-6.878 c 1.992,-18.595 -2.255,-34.065 -12.674,-45.999 -21.49,-24.612 -61.225,-24.903 -62.906,-24.903 h -10e-4 c -1.388,0 -2.714,0.577 -3.659,1.593 -0.945,1.016 -1.427,2.379 -1.328,3.764 2.018,28.253 11.713,48.778 28.814,61.006 14.459,10.338 30.748,11.881 39.17,11.881 2.277,0 4.17,-0.108 5.558,-0.225 l 14.206,13.61 v 68.25 c -26.858,0.701 -52.242,7.05 -73.691,18.476 -22.391,11.928 -38.963,28.938 -46.664,47.895 -0.626,1.542 -0.444,3.294 0.484,4.674 0.93,1.381 2.484,2.208 4.148,2.208 h 241.445 c 1.664,0 3.219,-0.827 4.148,-2.208 0.925,-1.383 1.107,-3.135 0.481,-4.677 z M 245.394,224.45 c 14.141,-16.226 38.901,-20.215 49.887,-21.194 -5.347,46.247 -33.238,56.436 -52.665,57.763 l 30.263,-28.993 c 1.994,-1.91 2.061,-5.075 0.151,-7.069 -1.91,-1.995 -5.076,-2.063 -7.069,-0.151 l -31.216,29.905 c 0.11,-12.095 3.666,-22.249 10.649,-30.261 z m -0.359,-101.277 c 14.151,-16.251 38.945,-20.262 49.948,-21.25 -5.534,47.199 -35.436,56.439 -52.616,57.775 l 30.517,-28.995 c 2.002,-1.902 2.083,-5.067 0.181,-7.069 -1.901,-2 -5.065,-2.082 -7.068,-0.181 l -31.61,30.035 c 0.099,-12.114 3.655,-22.286 10.648,-30.315 z m -84.962,0.28 c -2.002,-1.9 -5.166,-1.82 -7.068,0.181 -1.902,2.002 -1.822,5.167 0.18,7.069 l 30.516,28.995 c -17.181,-1.337 -47.081,-10.586 -52.616,-57.784 10.982,0.972 35.719,4.95 49.921,21.226 7.011,8.035 10.577,18.217 10.677,30.347 z m 0.036,101.351 c -1.994,-1.909 -5.158,-1.844 -7.07,0.151 -1.91,1.994 -1.842,5.159 0.152,7.069 l 30.263,28.993 c -19.428,-1.326 -47.322,-11.516 -52.665,-57.771 10.967,0.963 35.67,4.921 49.859,21.172 7.002,8.019 10.568,18.182 10.677,30.292 z M 195.133,65.007 c -3.063,-15.134 2.942,-32.627 17.855,-52.06 7.015,9.117 21.171,30.406 18.348,50.581 -1.234,8.822 -5.705,16.584 -13.302,23.172 V 56.768 c 0,-2.762 -2.238,-5 -5,-5 -2.762,0 -5,2.238 -5,5 V 86.886 C 203.146,82.483 197.211,75.275 195.133,65.007 Z ",
    id: "path324",
    style: {
      display: "inline",
      fill: "#ca8a04",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    },
    clipPath: "url(#clipPath2710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.034,384.173c-1.311,0-2.6-0.54-3.54-1.47c-0.931-0.93-1.46-2.22-1.46-3.53c0-1.32,0.529-2.61,1.46-3.54     c0.94-0.93,2.22-1.47,3.54-1.47s2.609,0.54,3.529,1.47c0.94,0.93,1.471,2.22,1.471,3.54c0,1.311-0.53,2.601-1.471,3.53     C215.634,383.633,214.355,384.173,213.034,384.173z",
    id: "path107",
    style: {
      enableBackground: "new 0 0 426.069 426.069",
      fill: "#854d0e",
      fillOpacity: 1,
      stroke: "#854d0e",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.034,407.953c-1.32,0-2.61-0.53-3.54-1.46c-0.92-0.931-1.46-2.22-1.46-3.54c0-1.32,0.54-2.61,1.47-3.53     c0.92-0.93,2.21-1.47,3.53-1.47s2.609,0.54,3.54,1.47c0.93,0.92,1.46,2.21,1.46,3.53c0,1.32-0.53,2.609-1.46,3.54     C215.644,407.423,214.355,407.953,213.034,407.953z",
    id: "path111",
    style: {
      enableBackground: "new 0 0 426.069 426.069",
      fill: "#854d0e",
      fillOpacity: 1,
      stroke: "#854d0e",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.474,396.063c-1.32,0-2.609-0.529-3.539-1.47c-0.931-0.93-1.461-2.22-1.461-3.53c0-1.319,0.53-2.609,1.461-3.539     c0.93-0.931,2.219-1.461,3.539-1.461c1.311,0,2.6,0.53,3.53,1.461c0.931,0.93,1.47,2.22,1.47,3.539c0,1.31-0.539,2.601-1.47,3.53     C180.074,395.534,178.794,396.063,177.474,396.063z",
    id: "path117",
    style: {
      enableBackground: "new 0 0 426.069 426.069",
      fill: "#854d0e",
      fillOpacity: 1,
      stroke: "#854d0e",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.595,396.063c-1.32,0-2.6-0.529-3.541-1.47c-0.93-0.93-1.459-2.22-1.459-3.53c0-1.319,0.529-2.609,1.469-3.539     c0.931-0.931,2.211-1.461,3.531-1.461c1.319,0,2.609,0.53,3.539,1.461c0.93,0.93,1.461,2.22,1.461,3.539     c0,1.31-0.531,2.601-1.461,3.53C251.204,395.534,249.914,396.063,248.595,396.063z",
    id: "path121",
    style: {
      enableBackground: "new 0 0 426.069 426.069",
      fill: "#854d0e",
      fillOpacity: 1,
      stroke: "#854d0e",
      strokeOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b05b6eee286208829c5a5e66220d4ee9.svg";
export { ForwardRef as ReactComponent };